import { registerComponent } from '@gig/magic-common';
import SweepstakesVerificationProgressComponent from './sweepstakes-verification-progress.vue.js';

var SweepstakesVerificationProgress = registerComponent(SweepstakesVerificationProgressComponent);

export { SweepstakesVerificationProgress };
